// CustomGraphBuilder.js - Γενικό UI που διαχειρίζεται όλα τα structure types
import React, { useState, useEffect } from "react";
import { Col } from "reactstrap";
import { useDarkMode } from "context/DarkModeProvider.js";

// Import των builders
import StackBuilder from "./CreateYourOwnBuilders/stackBuilder.js";
import QueueBuilder from "./CreateYourOwnBuilders/queueBuilder.js";
import ArrayBuilder from "./CreateYourOwnBuilders/arrayBuilder.js";
import GraphBuilder from "./CreateYourOwnBuilders/graphBuilder.js";
import LinkedListBuilder from "./CreateYourOwnBuilders/listBuilder.js"
import HashTableBuilder from "./CreateYourOwnBuilders/hashTableBuilder.js"
import SetBuilder from "./CreateYourOwnBuilders/setBuilder.js"
import TreeBuilder from "./CreateYourOwnBuilders/treeBuilder.js";
import { Link } from "react-router-dom";
import { Hash } from "lucide-react";

const structureTypeFromStorage = () => {
    const s = localStorage.getItem("structureLocation");
    if (!s) return "Graph";
    // Normalize common names
    if (["Tree", "Δέντρο"].includes(s)) return "Tree";
    if (["Graph", "Γράφος"].includes(s)) return "Graph";
    if (["List", "Λίστα"].includes(s)) return "List";
    if (["Array", "Πίνακας"].includes(s)) return "Array";
    if (["Stack", "Στοίβα"].includes(s)) return "Stack";
    if (["Queue", "Ουρά"].includes(s)) return "Queue";
    if (["HashTable", "Hash"].includes(s)) return "HashTable";
    return s;
};

const CustomGraphBuilder = () => {
    const structureType = structureTypeFromStorage();

    // State για τα builders που το χρειάζονται
    const [nodes, setNodes] = React.useState([]);
    const [nodeId, setNodeId] = React.useState(1);
    const [isLoading, setIsLoading] = useState(true);

    const { darkMode } = useDarkMode();


    const renderBuilder = () => {
        switch (structureType) {
            case "Array":
                return <ArrayBuilder nodes={nodes} setNodes={setNodes} nodeId={nodeId} setNodeId={setNodeId} />;
            case "Stack":
                return <StackBuilder nodes={nodes} setNodes={setNodes} nodeId={nodeId} setNodeId={setNodeId} />;
            case "Queue":
                return <QueueBuilder nodes={nodes} setNodes={setNodes} nodeId={nodeId} setNodeId={setNodeId} />;
            case "HashTable":
                return <HashTableBuilder></HashTableBuilder>
            case "List":
                return <LinkedListBuilder></LinkedListBuilder>
            case "Set":
                return <SetBuilder></SetBuilder>
            case "Graph":
                return <GraphBuilder structureType={structureType} />;
            case "Tree":
                return <TreeBuilder />;
            default:
                return <GraphBuilder structureType="Graph" />;
        }
    };

    // Mapping για τα ελληνικά ονόματα και emojis
    const getStructureDisplayInfo = (type) => {
        const displayMap = {
            "Graph": { name: "Γράφο", emoji: "🕸️" },
            "Tree": { name: "Δέντρο", emoji: "🌳" },
            "List": { name: "Λίστα", emoji: "📋" },
            "Array": { name: "Πίνακα", emoji: "📊" },
            "Stack": { name: "Στοίβα", emoji: "🗄️" },
            "Queue": { name: "Ουρά", emoji: "🚶‍♂️" }
        };
        return displayMap[type] || { name: type, emoji: "🔧" };
    };

    const displayInfo = getStructureDisplayInfo(structureType);

    return (


        <Col style={{
            width: "100%",
            minHeight: "80vh",
            borderRadius: "10px",
            margin: "auto",
            marginTop: "2%",
            background: darkMode ? "#0F172A" : "var(--lightModeBack)",
            padding: "30px"
        }}>
            {/* Header Section */}


            {/* Content Section */}
            <div /*style={{
                background: darkMode ? "#0F172A" : "var(--lightModeBack)",

                borderRadius: "15px",
                padding: "25px",
                boxShadow: darkMode ? "0 4px 6px rgba(0, 0, 0, 0.1)" : "none",
                minHeight: "500px"
            }}*/>
                {renderBuilder()}
            </div>

        </Col>
    );
};

export default CustomGraphBuilder;